import { Schema } from "prosemirror-model";

export const editorSchema = new Schema({
  nodes: {
    doc: {
      content: "ordered_list",
    },
    ordered_list: {
      attrs: {
        order: { default: 1 },
      },
      content: "list_item+",
      toDOM: node => ["ol", { start: node.attrs.order }, 0],
      parseDOM: [
        {
          tag: "ol",
          getAttrs: dom => ({
            order: dom.hasAttribute("start") ? Number(dom.getAttribute("start")) : 1,
          }),
        },
      ],
    },
    list_item: {
      attrs: { id: { default: "" } },
      content: "paragraph (ordered_list)?",
      toDOM: node => {
        const attrs = node.attrs.id ? { "data-item-id": node.attrs.id } : undefined;
        return ["li", attrs, 0];
      },
      parseDOM: [
        {
          tag: "li",
          getAttrs: dom => ({
            id: dom.getAttribute("data-item-id") || "",
          }),
        },
      ],
    },
    paragraph: {
      content: "text*",
      group: "block",
      parseDOM: [{ tag: "p" }],
      toDOM: () => ["p", 0],
    },
    text: {
      group: "inline",
    },
  },
  marks: {},
});
